var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"preloader"},[_c('div',{attrs:{"id":"status"}},[_c('b-spinner',{staticStyle:{"width":"3rem","height":"3rem"},attrs:{"label":"Large Spinner","variant":"primary"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }